import { useRef } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../../static/styles/global'
import HomeDetailsHeader from '../../../home/HomeDetailsHeader'
import Card from '../../../shared/card/Card'
import CustomButton from '../../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../../stores/onboarding'
import { useInitializeStore } from '../../../../stores/initialize'
import { usePersonalStore } from '../../../../stores/personalInfo'
import Toast from 'react-native-toast-message'
import moment from 'moment'

const VowellsInformationForm = ({ navigation, route }: any): JSX.Element => {
    const formikRef = useRef(null)
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        description
    } = params

    const { loading, postVowellsForm } = useFormsStore((state) => ({
        loading: state.loading,
        postVowellsForm: state.postVowellsForm
    }))
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()

    const TODAY = moment().format('MM/DD/YYYY')

    const intialValues = {
        employeeHandbookInitials: '',
        tvAcknowlInitials: '',
        tvAdditionalHBAcknowlInitials: '',
        tvDrCodeAcknoInitials: '',
        tvTobaccoAlcoholInitials: ''
    }

    const voschema = yup.object({
        employeeHandbookInitials: yup
            .string()
            .matches(/^[A-Za-z]+$/, 'Letters only')
            .required('Employee Handbook initials are required '),
        tvAcknowlInitials: yup
            .string()
            .matches(/^[A-Za-z]+$/, 'Letters only')
            .required('TV Acknowledgment initials are required'),
        tvAdditionalHBAcknowlInitials: yup
            .string()
            .matches(/^[A-Za-z]+$/, 'Letters only')
            .required('TV Additional Handbook Acknowledgment initials are required'),
        tvDrCodeAcknoInitials: yup
            .string()
            .matches(/^[A-Za-z]+$/, 'Letters only')
            .required('TV Dress Code Acknowledgment initials are required'),
        tvTobaccoAlcoholInitials: yup
            .string()
            .matches(/^[A-Za-z]+$/, 'Letters only')
            .required('TV Tobacco & Alcohol Policy initials are required')
    })

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={description || 'Vowells Acknowledgement'}
                    />
                </View>
                <View style={{ borderColor: 'white', borderStyle: 'dashed', borderWidth: 2, padding: 5, margin: 5 }}>
                    <Text style={{ textAlign: 'center', fontWeight: 'bold', color: 'white' }} >*** INSTRUCTIONS: Click on your name above to view the “Employee Onboarding Resources” section of the main menu. Please review all forms before making acknowledgments below. ***</Text>
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    innerRef={formikRef}
                    initialValues={{ ...intialValues }}
                    validationSchema={voschema}
                    onSubmit={async (values, actions) => {
                        const data = {
                            completeOnline: mode === 'online' ? true : false,
                            essUserKey: initializestore.initializeData.userkey,
                            entityId: personalstore.personalData?.entityId,
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            essObKey: essUserOnBoardingKey,
                            ehinitial: values.employeeHandbookInitials.toUpperCase() + "  " + TODAY,
                            tvainitial: values.tvAcknowlInitials.toUpperCase() + "  " + TODAY,
                            tvahbinitial:
                                values.tvAdditionalHBAcknowlInitials.toUpperCase() + "  " + TODAY,
                            tvdrinitial: values.tvDrCodeAcknoInitials.toUpperCase() + "  " + TODAY,
                            tvtainitial: values.tvTobaccoAlcoholInitials.toUpperCase() + "  " + TODAY
                        }

                        const response = await postVowellsForm(data)
                        if (response?.success) {
                            if (mode === 'upload') {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message || 'Form submitted successfully',
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            } else {
                                navigation.navigate('VowellsInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,
                                    description
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message || 'Failed to submit form',
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }
                    }}
                >
                    {(props) => (
                        <Card>
                            {/* Question 1 */}
                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ justifyContent: 'center', width: '50%' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {
                                            'Please enter your initials to acknowledge the Employee Handbook *'
                                        }
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.employeeHandbookInitials}
                                        autoCapitalize="characters"
                                        onChangeText={(text) => props.setFieldValue(
                                            'employeeHandbookInitials', text.toUpperCase()
                                        )}
                                    />
                                    {props.touched.employeeHandbookInitials &&
                                        props.errors.employeeHandbookInitials && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.employeeHandbookInitials as string}
                                            </Text>
                                        )}
                                </View>
                            </View>

                            {/* Question 2 */}
                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ justifyContent: 'center', width: '50%' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {
                                            'Please enter your initials to acknowledge the TV Acknowledgment *'
                                        }
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.tvAcknowlInitials}
                                        autoCapitalize="characters"
                                        onChangeText={(text) => props.setFieldValue(
                                            'tvAcknowlInitials', text.toUpperCase()
                                        )}
                                    />
                                    {props.touched.tvAcknowlInitials &&
                                        props.errors.tvAcknowlInitials && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.tvAcknowlInitials as string}
                                            </Text>
                                        )}
                                </View>
                            </View>

                            {/* Question 3 */}
                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ justifyContent: 'center', width: '50%' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {
                                            'Please enter your initials to acknowledge the TV Additional Handbook Acknowledgment *'
                                        }
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.tvAdditionalHBAcknowlInitials}
                                        autoCapitalize="characters"
                                        onChangeText={(text) => props.setFieldValue(
                                            'tvAdditionalHBAcknowlInitials', text.toUpperCase()
                                        )}
                                    />
                                    {props.touched.tvAdditionalHBAcknowlInitials &&
                                        props.errors.tvAdditionalHBAcknowlInitials && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.tvAdditionalHBAcknowlInitials as string}
                                            </Text>
                                        )}
                                </View>
                            </View>

                            {/* Question 4 */}
                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ justifyContent: 'center', width: '50%' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {
                                            'Please enter your initials to acknowledge the TV Dress Code Acknowledgment *'
                                        }
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.tvDrCodeAcknoInitials}
                                        autoCapitalize="characters"
                                        onChangeText={(text) => props.setFieldValue(
                                            'tvDrCodeAcknoInitials', text.toUpperCase()
                                        )}
                                    />
                                    {props.touched.tvDrCodeAcknoInitials &&
                                        props.errors.tvDrCodeAcknoInitials && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.tvDrCodeAcknoInitials as string}
                                            </Text>
                                        )}
                                </View>
                            </View>

                            {/* Question 5 */}
                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ justifyContent: 'center', width: '50%' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {
                                            'Please enter your initials to acknowledge the TV Tobacco & Alcohol Policy *'
                                        }
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.tvTobaccoAlcoholInitials}
                                        autoCapitalize="characters"
                                        onChangeText={(text) => props.setFieldValue(
                                            'tvTobaccoAlcoholInitials', text.toUpperCase()
                                        )}
                                    />
                                    {props.touched.tvTobaccoAlcoholInitials &&
                                        props.errors.tvTobaccoAlcoholInitials && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.tvTobaccoAlcoholInitials as string}
                                            </Text>
                                        )}
                                </View>
                            </View>

                            {loading ? (
                                <ActivityIndicator />
                            ) : (
                                <View style={{ margin: 10 }}>
                                    <CustomButton
                                        text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                        onPress={props.handleSubmit}
                                    />
                                </View>
                            )}
                        </Card>
                    )}
                </Formik>
            </View>
        </KeyboardAwareScrollView>
    )
}

export default VowellsInformationForm
